import {
  Box,
  Collapse,
  createStyles,
  makeStyles,
  Table,
  TableBody,
  TableRow,
  withWidth,
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import moment from "moment-timezone";
import React from "react";
import { formatCurrency } from "../../../components/Utils/Currency";
import {
  StyledTableCell,
  StyledTableRow,
  StyledTableCellStruct,
} from "../../../components/CustomStyles/CustomTable";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      width: "100%",
    },
    paper1: {
      marginTop: 15,
      backgroundColor: theme.palette.background.paper,
    },
    headingBold: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: "bolder",
      padding: 6,
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      padding: 6,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
  })
);

const Panel = React.memo(({ transaction }) => {
  const classes = useStyles();
  const [openRow, setOpenRow] = React.useState(false);
  const order = transaction.orders[0];
  const tenant = order.tenant;

  return (
    <React.Fragment>
      <StyledTableRow onClick={() => setOpenRow(!openRow)}>
        <StyledTableCell style={{ color: "#2196F3" }}>
          <small>{transaction.unique_id}</small>
        </StyledTableCell>
        <StyledTableCell>{transaction.user.name || ""}</StyledTableCell>
        <StyledTableCell>
          {moment(transaction.create_time)
            .tz(tenant?.property?.timezone)
            .format("DD-MM-YYYY")}
        </StyledTableCell>
        <StyledTableCell>
          {moment(transaction.create_time)
            .add(7, "days")
            .tz(tenant?.property?.timezone)
            .format("DD-MM-YYYY")}
        </StyledTableCell>
        <StyledTableCell>
          {order.progress === "ready" && "Menunggu konfirmasi pembeli"}
          {order.progress === "complete" &&
            transaction.settled_st === false &&
            " Menunggu dana siap dilepaskan"}
          {order.progress === "complete" &&
            transaction.settled_st === true &&
            "Dana siap dilepaskan"}
        </StyledTableCell>
        <StyledTableCell style={{ color: "#4CAF50" }}>
          <b>
            {formatCurrency(
              tenant?.property?.currency,
              order?.sub_total_amount.toString()
            )}
            {}
          </b>
        </StyledTableCell>
      </StyledTableRow>
      <StyledTableRow>
        <StyledTableCell colSpan={7} style={{ padding: 0, border: "none" }}>
          <Collapse
            in={openRow}
            timeout="auto"
            unmountOnExit
            style={{ backgroundColor: "#F5F5F5", padding: 16 }}
          >
            <Box
              margin={0}
              style={{ width: "100%", backgroundColor: "#F5F5F5" }}
            >
              <Table size="small" aria-label="detail order">
                <TableBody>
                  {order.items
                    ? order.items.map((item, i) => {
                        return (
                          <TableRow key={i}>
                            <StyledTableCellStruct
                              style={{
                                border:
                                  order.items.length <= 1
                                    ? "0px solid grey"
                                    : "",
                              }}
                            >
                              <img
                                src={order?.tenant?.logo?.square}
                                alt="logo"
                                style={{ width: 50, height: 50 }}
                              />
                              <span
                                style={{
                                  marginLeft: 15,
                                  color: "#212121",
                                  fontSize: 12,
                                  position: "absolute",
                                }}
                              >
                                {item?.name}
                                <br />
                                <small>
                                  {item?.description}
                                  <br />x{item?.qty}
                                </small>
                              </span>
                            </StyledTableCellStruct>
                            <StyledTableCellStruct
                              align="right"
                              style={{
                                border:
                                  order.items.length <= 1
                                    ? "0px solid grey"
                                    : "",
                              }}
                            >
                              <b>
                                {formatCurrency(
                                  tenant?.property?.currency,
                                  (
                                    item.qty *
                                    (item.discounted_price
                                      ? item.discounted_price
                                      : item.price.value)
                                  ).toString()
                                )}
                              </b>
                            </StyledTableCellStruct>
                          </TableRow>
                        );
                      })
                    : ""}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </StyledTableCell>
      </StyledTableRow>
    </React.Fragment>
  );
});

const PanelHasRelease = React.memo(({ transaction }) => {
  const classes = useStyles();
  const [openRow, setOpenRow] = React.useState(false);
  const order = transaction.items[0];
  const tenant = transaction.tenant;

  return (
    <React.Fragment>
      <StyledTableRow onClick={() => setOpenRow(!openRow)}>
        <StyledTableCell style={{ color: "#2196F3" }}>
          <small>{transaction.transaction_id}</small>
        </StyledTableCell>
        <StyledTableCell>{transaction.user.name || ""}</StyledTableCell>
        <StyledTableCell>
          {moment(transaction.trx_time)
            .tz(tenant?.property?.timezone)
            .format("DD-MM-YYYY")}
        </StyledTableCell>
        <StyledTableCell>
          {moment(transaction.create_time)
            .add(7, "days")
            .tz(tenant?.property?.timezone)
            .format("DD-MM-YYYY")}
        </StyledTableCell>
        <StyledTableCell>
          {transaction.progress === "wait" && "Menunggu proses transfer"}
          {transaction.progress === "process" && "Proses transfer"}
          {transaction.progress === "complete" && "Penarikan dana berhasil"}
          {transaction.progress === "failed" && "Penarikan dana gagal"}
        </StyledTableCell>
        <StyledTableCell style={{ color: "#4CAF50" }}>
          <b>
            {formatCurrency(
              tenant?.property?.currency,
              transaction?.total_amount.toString()
            )}
            {}
          </b>
        </StyledTableCell>
      </StyledTableRow>
      <StyledTableRow>
        <StyledTableCell colSpan={7} style={{ padding: 0, border: "none" }}>
          <Collapse
            in={openRow}
            timeout="auto"
            unmountOnExit
            style={{ backgroundColor: "#F5F5F5", padding: 16 }}
          >
            <Box
              margin={0}
              style={{ width: "100%", backgroundColor: "#F5F5F5" }}
            >
              <Table size="small" aria-label="detail order">
                <TableBody>
                  {order.items
                    ? order.items.map((item, i) => {
                        return (
                          <TableRow key={i}>
                            <StyledTableCellStruct
                              style={{
                                border:
                                  order.items.length <= 1
                                    ? "0px solid grey"
                                    : "",
                              }}
                            >
                              <img
                                src={order?.tenant?.logo?.square}
                                alt="logo"
                                style={{ width: 50, height: 50 }}
                              />
                              <span
                                style={{
                                  marginLeft: 15,
                                  color: "#212121",
                                  fontSize: 12,
                                  position: "absolute",
                                }}
                              >
                                {item?.name}
                                <br />
                                <small>
                                  {item?.description}
                                  <br />x{item?.qty}
                                </small>
                              </span>
                            </StyledTableCellStruct>
                            <StyledTableCellStruct
                              align="right"
                              style={{
                                border:
                                  order.items.length <= 1
                                    ? "0px solid grey"
                                    : "",
                              }}
                            >
                              <b>
                                {formatCurrency(
                                  tenant?.property?.currency,
                                  (
                                    item.qty *
                                    (item.discounted_price
                                      ? item.discounted_price
                                      : item.price.value)
                                  ).toString()
                                )}
                              </b>
                            </StyledTableCellStruct>
                          </TableRow>
                        );
                      })
                    : ""}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </StyledTableCell>
      </StyledTableRow>
    </React.Fragment>
  );
});

const PanelLoading = React.memo(({ id, width }) => {
  return (
    <StyledTableRow>
      <StyledTableCell width="5%">
        <Skeleton
          variant="text"
          animation="wave"
          width={width === "sm" || width === "xs" || width === "md" ? 40 : 60}
        />
      </StyledTableCell>
      <StyledTableCell>
        <Skeleton
          variant="text"
          animation="wave"
          width={width === "sm" || width === "xs" || width === "md" ? 80 : 100}
        />
      </StyledTableCell>
      <StyledTableCell>
        <Skeleton
          variant="text"
          animation="wave"
          width={width === "sm" || width === "xs" || width === "md" ? 80 : 100}
        />
      </StyledTableCell>
      <StyledTableCell>
        <Skeleton
          variant="text"
          animation="wave"
          width={width === "sm" || width === "xs" || width === "md" ? 80 : 100}
        />
      </StyledTableCell>
      <StyledTableCell>
        <Skeleton
          variant="text"
          animation="wave"
          width={width === "sm" || width === "xs" || width === "md" ? 80 : 100}
        />
      </StyledTableCell>
      <StyledTableCell>
        <Skeleton
          variant="text"
          animation="wave"
          width={width === "sm" || width === "xs" || width === "md" ? 80 : 100}
        />
      </StyledTableCell>
    </StyledTableRow>
  );
});

const ListPanel = withWidth()(Panel);
const ListPanelHasRelease = withWidth()(PanelHasRelease);
const ListPanelLoading = withWidth()(PanelLoading);

export { ListPanel, ListPanelHasRelease, ListPanelLoading };
